export const sanitize = (string) => string.replace(/oziva|virgio/gi, "").trim();
